import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const IdentityVerification = () => {

  const navigate = useNavigate();
  const goTo = (route) => {
    navigate(route); // Navigate to the About page
  };

  return (
   <div className="flexing_content flex_container margin-top-20 complete-verification-body">      
    <section className="complete-verification">
      <div className="column_80_ complete-verification-details">
        <h3>Verify your account</h3>
        <p>Complete your account verification to access all features and keep it secure</p>
      </div>
      <div className="column_20_ nopadding thebutton-verify">
        <button className="btn  btn-small-extende-right" onClick={(e) => goTo('/kyc/verification')}>
          Get Verified
        </button>
      </div>
    </section>
   </div> 
  );
};

export default IdentityVerification;
